<div  id="blocCommercial" class="container sticky" *ngIf="showMe"  [ngClass]="toggleStyle? 'background_grey':'background_white'" >

    <div class="logo_area">
        
        <img [ngClass]="toggleStyle? 'display_none':'img_cross'"  src="assets/images/quit_cross.svg" (click)="closeBloc()">
        
        <div class="logo_partener">
            <div class="logo_img">
                <a *ngIf="parcelInformations.parcel.customerCoBrandingURL" href="{{parcelInformations.parcel.customerCoBrandingURL}}" target="_blank" (click)="generateTagClick()">
                    <img src="{{parcelInformations.parcel.customerCoBrandingBannerMobile}}" dataqsi="partnerLogo">
                </a>
                <a *ngIf="!parcelInformations.parcel.customerCoBrandingURL">
                    <img src="{{parcelInformations.parcel.customerCoBrandingBannerMobile}}" dataqsi="partnerLogo">
                </a>
            </div>
        </div>

    </div>
</div>